//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ProjectApiClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Returns all projects. A filter on name, quoteNumber and projectNumber can be applied.
     * @param query (optional) 
     * @return Success
     */
    getAll(query: string | undefined , cancelToken?: CancelToken | undefined): Promise<ProjectDtoListResponse> {
        let url_ = this.baseUrl + "/api/Project/GetAll?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "Query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ProjectDtoListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectDtoListResponse.fromJS(resultData200);
            return Promise.resolve<ProjectDtoListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectDtoListResponse>(null as any);
    }

    /**
     * Returns a single project matching the provided filter.
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<ProjectDtoResponse> {
        let url_ = this.baseUrl + "/api/Project/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ProjectDtoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectDtoResponse.fromJS(resultData200);
            return Promise.resolve<ProjectDtoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectDtoResponse>(null as any);
    }
}

export class ProjectPhaseApiClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Returns all ProjectPhases. Can be filtered by BusinessUnit, StateCode and StatusCode
     * @param businessUnitId (optional) 
     * @param stateCode (optional) 
     * @param statusCode (optional) 
     * @return Success
     */
    getAll(businessUnitId: string | undefined, stateCode: Paa_projectlearningmasterdataphaseState | undefined, statusCode: Paa_projectlearningmasterdataphase_statuscode | undefined , cancelToken?: CancelToken | undefined): Promise<ProjectPhaseDtoListResponse> {
        let url_ = this.baseUrl + "/api/ProjectPhase/GetAll?";
        if (businessUnitId === null)
            throw new Error("The parameter 'businessUnitId' cannot be null.");
        else if (businessUnitId !== undefined)
            url_ += "BusinessUnitId=" + encodeURIComponent("" + businessUnitId) + "&";
        if (stateCode === null)
            throw new Error("The parameter 'stateCode' cannot be null.");
        else if (stateCode !== undefined)
            url_ += "StateCode=" + encodeURIComponent("" + stateCode) + "&";
        if (statusCode === null)
            throw new Error("The parameter 'statusCode' cannot be null.");
        else if (statusCode !== undefined)
            url_ += "StatusCode=" + encodeURIComponent("" + statusCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ProjectPhaseDtoListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectPhaseDtoListResponse.fromJS(resultData200);
            return Promise.resolve<ProjectPhaseDtoListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectPhaseDtoListResponse>(null as any);
    }
}

export class ProjectTypeApiClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Returns all ProjectTypes. Can be filtered by BusinessUnit, StateCode and StatusCode
     * @param businessUnitId (optional) 
     * @param stateCode (optional) 
     * @param statusCode (optional) 
     * @return Success
     */
    getAll(businessUnitId: string | undefined, stateCode: Paa_projectlearningmasterdatatypeState | undefined, statusCode: Paa_projectlearningmasterdatatype_statuscode | undefined , cancelToken?: CancelToken | undefined): Promise<ProjectTypeDtoListResponse> {
        let url_ = this.baseUrl + "/api/ProjectType/GetAll?";
        if (businessUnitId === null)
            throw new Error("The parameter 'businessUnitId' cannot be null.");
        else if (businessUnitId !== undefined)
            url_ += "BusinessUnitId=" + encodeURIComponent("" + businessUnitId) + "&";
        if (stateCode === null)
            throw new Error("The parameter 'stateCode' cannot be null.");
        else if (stateCode !== undefined)
            url_ += "StateCode=" + encodeURIComponent("" + stateCode) + "&";
        if (statusCode === null)
            throw new Error("The parameter 'statusCode' cannot be null.");
        else if (statusCode !== undefined)
            url_ += "StatusCode=" + encodeURIComponent("" + statusCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ProjectTypeDtoListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectTypeDtoListResponse.fromJS(resultData200);
            return Promise.resolve<ProjectTypeDtoListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectTypeDtoListResponse>(null as any);
    }
}

export class SectionApiClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Returns all Sections. Can be filtered by StateCode, StatusCode
     * @param stateCode (optional) 
     * @param statusCode (optional) 
     * @return Success
     */
    getAll(stateCode: Paa_sektionState | undefined, statusCode: Paa_sektion_statuscode | undefined , cancelToken?: CancelToken | undefined): Promise<SectionDtoListResponse> {
        let url_ = this.baseUrl + "/api/Section/GetAll?";
        if (stateCode === null)
            throw new Error("The parameter 'stateCode' cannot be null.");
        else if (stateCode !== undefined)
            url_ += "StateCode=" + encodeURIComponent("" + stateCode) + "&";
        if (statusCode === null)
            throw new Error("The parameter 'statusCode' cannot be null.");
        else if (statusCode !== undefined)
            url_ += "StatusCode=" + encodeURIComponent("" + statusCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<SectionDtoListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SectionDtoListResponse.fromJS(resultData200);
            return Promise.resolve<SectionDtoListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SectionDtoListResponse>(null as any);
    }

    /**
     * Returns all parent Sections including their children. Can be filtered by StateCode, StatusCode
     * @param stateCode (optional) 
     * @param statusCode (optional) 
     * @return Success
     */
    getAllParentsWithChildren(stateCode: Paa_sektionState | undefined, statusCode: Paa_sektion_statuscode | undefined , cancelToken?: CancelToken | undefined): Promise<SectionDtoListResponse> {
        let url_ = this.baseUrl + "/api/Section/GetAllParentsWithChildren?";
        if (stateCode === null)
            throw new Error("The parameter 'stateCode' cannot be null.");
        else if (stateCode !== undefined)
            url_ += "StateCode=" + encodeURIComponent("" + stateCode) + "&";
        if (statusCode === null)
            throw new Error("The parameter 'statusCode' cannot be null.");
        else if (statusCode !== undefined)
            url_ += "StatusCode=" + encodeURIComponent("" + statusCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllParentsWithChildren(_response);
        });
    }

    protected processGetAllParentsWithChildren(response: AxiosResponse): Promise<SectionDtoListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SectionDtoListResponse.fromJS(resultData200);
            return Promise.resolve<SectionDtoListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SectionDtoListResponse>(null as any);
    }
}

export class SurveyResultApiClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Returns all survey results that matches the provided filter. Used to populate the heat map.
     * @param projects (optional) 
     * @param sections (optional) 
     * @param projectTypes (optional) 
     * @param surveyTemplates (optional) 
     * @param roles (optional) 
     * @param periodFrom (optional) 
     * @param periodTo (optional) 
     * @param latestForecastLow (optional) 
     * @param latestForecastHigh (optional) 
     * @return Success
     */
    getAll(projects: string[] | undefined, sections: string[] | undefined, projectTypes: string[] | undefined, surveyTemplates: string[] | undefined, roles: Role[] | undefined, periodFrom: Date | undefined, periodTo: Date | undefined, latestForecastLow: number | undefined, latestForecastHigh: number | undefined , cancelToken?: CancelToken | undefined): Promise<SurveyResultDtoListResponse> {
        let url_ = this.baseUrl + "/api/SurveyResult/GetAll?";
        if (projects === null)
            throw new Error("The parameter 'projects' cannot be null.");
        else if (projects !== undefined)
            projects && projects.forEach(item => { url_ += "Projects=" + encodeURIComponent("" + item) + "&"; });
        if (sections === null)
            throw new Error("The parameter 'sections' cannot be null.");
        else if (sections !== undefined)
            sections && sections.forEach(item => { url_ += "Sections=" + encodeURIComponent("" + item) + "&"; });
        if (projectTypes === null)
            throw new Error("The parameter 'projectTypes' cannot be null.");
        else if (projectTypes !== undefined)
            projectTypes && projectTypes.forEach(item => { url_ += "ProjectTypes=" + encodeURIComponent("" + item) + "&"; });
        if (surveyTemplates === null)
            throw new Error("The parameter 'surveyTemplates' cannot be null.");
        else if (surveyTemplates !== undefined)
            surveyTemplates && surveyTemplates.forEach(item => { url_ += "SurveyTemplates=" + encodeURIComponent("" + item) + "&"; });
        if (roles === null)
            throw new Error("The parameter 'roles' cannot be null.");
        else if (roles !== undefined)
            roles && roles.forEach(item => { url_ += "Roles=" + encodeURIComponent("" + item) + "&"; });
        if (periodFrom === null)
            throw new Error("The parameter 'periodFrom' cannot be null.");
        else if (periodFrom !== undefined)
            url_ += "PeriodFrom=" + encodeURIComponent(periodFrom ? "" + periodFrom.toISOString() : "") + "&";
        if (periodTo === null)
            throw new Error("The parameter 'periodTo' cannot be null.");
        else if (periodTo !== undefined)
            url_ += "PeriodTo=" + encodeURIComponent(periodTo ? "" + periodTo.toISOString() : "") + "&";
        if (latestForecastLow === null)
            throw new Error("The parameter 'latestForecastLow' cannot be null.");
        else if (latestForecastLow !== undefined)
            url_ += "LatestForecastLow=" + encodeURIComponent("" + latestForecastLow) + "&";
        if (latestForecastHigh === null)
            throw new Error("The parameter 'latestForecastHigh' cannot be null.");
        else if (latestForecastHigh !== undefined)
            url_ += "LatestForecastHigh=" + encodeURIComponent("" + latestForecastHigh) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<SurveyResultDtoListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SurveyResultDtoListResponse.fromJS(resultData200);
            return Promise.resolve<SurveyResultDtoListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyResultDtoListResponse>(null as any);
    }

    /**
     * Returns the SurveyResult including topics and questions
     * @param id The id of the SurveyResult
     * @return Success
     */
    get(id: string , cancelToken?: CancelToken | undefined): Promise<SurveyResultDtoResponse> {
        let url_ = this.baseUrl + "/api/SurveyResult/Get?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<SurveyResultDtoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SurveyResultDtoResponse.fromJS(resultData200);
            return Promise.resolve<SurveyResultDtoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyResultDtoResponse>(null as any);
    }

    /**
     * Returns the data needed to display the "Forbedringsoversigt" opened from the "Project Details" page
     * @param id The id of the project for which the "Forbedringsoversigt" should be displayed
     * @return Success
     */
    getReasonActionOverviewByProjectId(id: string , cancelToken?: CancelToken | undefined): Promise<SurveyResultDtoListResponse> {
        let url_ = this.baseUrl + "/api/SurveyResult/GetReasonActionOverviewByProjectId?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReasonActionOverviewByProjectId(_response);
        });
    }

    protected processGetReasonActionOverviewByProjectId(response: AxiosResponse): Promise<SurveyResultDtoListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SurveyResultDtoListResponse.fromJS(resultData200);
            return Promise.resolve<SurveyResultDtoListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyResultDtoListResponse>(null as any);
    }

    /**
     * Create survey result and returns the id
     * @param body (optional) Contains the needed information to create the survey result
     * @return Success
     */
    post(body: CreateSurveyResultRequest | undefined , cancelToken?: CancelToken | undefined): Promise<GuidResponse> {
        let url_ = this.baseUrl + "/api/SurveyResult/Post";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<GuidResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = GuidResponse.fromJS(resultData201);
            return Promise.resolve<GuidResponse>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GuidResponse>(null as any);
    }

    /**
     * Update the answers to the provided surveyresult questions.
     * @param body (optional) 
     * @return Success
     */
    saveSurveyAsDraft(body: SurveyResultSaveAsDraftRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SurveyResult/SaveSurveyAsDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSurveyAsDraft(_response);
        });
    }

    protected processSaveSurveyAsDraft(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Complete the surveyresult after updating with the provided answers.
    If some questions are still not answered, an error will be thrown.
     * @param body (optional) 
     * @return Success
     */
    saveSurveyAsCompleted(body: SurveyResultSaveAsCompletedRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SurveyResult/SaveSurveyAsCompleted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveSurveyAsCompleted(_response);
        });
    }

    protected processSaveSurveyAsCompleted(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Supply reason and actions for a survey, without completing the survey.
     * @param body (optional) 
     * @return Success
     */
    saveReasonActionAsDraft(body: ReasonActionSaveAsDraftOrCompletedRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SurveyResult/SaveReasonActionAsDraft";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveReasonActionAsDraft(_response);
        });
    }

    protected processSaveReasonActionAsDraft(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Supply reason and actions for a survey, and complete the survey when done.
     * @param body (optional) 
     * @return Success
     */
    saveReasonActionAsCompleted(body: ReasonActionSaveAsDraftOrCompletedRequestDto | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/SurveyResult/SaveReasonActionAsCompleted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveReasonActionAsCompleted(_response);
        });
    }

    protected processSaveReasonActionAsCompleted(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SurveyRootTopicApiClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @param businessUnitId (optional) 
     * @param stateCode (optional) 
     * @param statusCode (optional) 
     * @return Success
     */
    getAll(businessUnitId: string | undefined, stateCode: Paa_surveyroottopicState | undefined, statusCode: Paa_surveyroottopic_statuscode | undefined , cancelToken?: CancelToken | undefined): Promise<SurveyRootTopicDtoListResponse> {
        let url_ = this.baseUrl + "/api/SurveyRootTopic/GetAll?";
        if (businessUnitId === null)
            throw new Error("The parameter 'businessUnitId' cannot be null.");
        else if (businessUnitId !== undefined)
            url_ += "BusinessUnitId=" + encodeURIComponent("" + businessUnitId) + "&";
        if (stateCode === null)
            throw new Error("The parameter 'stateCode' cannot be null.");
        else if (stateCode !== undefined)
            url_ += "StateCode=" + encodeURIComponent("" + stateCode) + "&";
        if (statusCode === null)
            throw new Error("The parameter 'statusCode' cannot be null.");
        else if (statusCode !== undefined)
            url_ += "StatusCode=" + encodeURIComponent("" + statusCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<SurveyRootTopicDtoListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SurveyRootTopicDtoListResponse.fromJS(resultData200);
            return Promise.resolve<SurveyRootTopicDtoListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyRootTopicDtoListResponse>(null as any);
    }
}

export class SurveyTemplateApiClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Returns all SurveyTemplates
     * @return Success
     */
    getAll(  cancelToken?: CancelToken | undefined): Promise<SurveyTemplateDtoListResponse> {
        let url_ = this.baseUrl + "/api/SurveyTemplate/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<SurveyTemplateDtoListResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SurveyTemplateDtoListResponse.fromJS(resultData200);
            return Promise.resolve<SurveyTemplateDtoListResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SurveyTemplateDtoListResponse>(null as any);
    }
}

export class SystemUserApiClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * Returns the user related to the bearer token set in the authorization header
     * @return Success
     */
    getByBearerToken(  cancelToken?: CancelToken | undefined): Promise<SystemUserDtoResponse> {
        let url_ = this.baseUrl + "/api/SystemUser/GetByBearerToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByBearerToken(_response);
        });
    }

    protected processGetByBearerToken(response: AxiosResponse): Promise<SystemUserDtoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SystemUserDtoResponse.fromJS(resultData200);
            return Promise.resolve<SystemUserDtoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SystemUserDtoResponse>(null as any);
    }
}

export class BusinessUnitDto implements IBusinessUnitDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    members?: SystemUserDto[] | undefined;
    surveyTemplates?: SurveyTemplateDto[] | undefined;
    surveyRootTopics?: SurveyRootTopicDto[] | undefined;
    projectPhases?: ProjectPhaseDto[] | undefined;

    constructor(data?: IBusinessUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["members"])) {
                this.members = [] as any;
                for (let item of _data["members"])
                    this.members!.push(SystemUserDto.fromJS(item));
            }
            if (Array.isArray(_data["surveyTemplates"])) {
                this.surveyTemplates = [] as any;
                for (let item of _data["surveyTemplates"])
                    this.surveyTemplates!.push(SurveyTemplateDto.fromJS(item));
            }
            if (Array.isArray(_data["surveyRootTopics"])) {
                this.surveyRootTopics = [] as any;
                for (let item of _data["surveyRootTopics"])
                    this.surveyRootTopics!.push(SurveyRootTopicDto.fromJS(item));
            }
            if (Array.isArray(_data["projectPhases"])) {
                this.projectPhases = [] as any;
                for (let item of _data["projectPhases"])
                    this.projectPhases!.push(ProjectPhaseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BusinessUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.members)) {
            data["members"] = [];
            for (let item of this.members)
                data["members"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyTemplates)) {
            data["surveyTemplates"] = [];
            for (let item of this.surveyTemplates)
                data["surveyTemplates"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyRootTopics)) {
            data["surveyRootTopics"] = [];
            for (let item of this.surveyRootTopics)
                data["surveyRootTopics"].push(item.toJSON());
        }
        if (Array.isArray(this.projectPhases)) {
            data["projectPhases"] = [];
            for (let item of this.projectPhases)
                data["projectPhases"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBusinessUnitDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    members?: SystemUserDto[] | undefined;
    surveyTemplates?: SurveyTemplateDto[] | undefined;
    surveyRootTopics?: SurveyRootTopicDto[] | undefined;
    projectPhases?: ProjectPhaseDto[] | undefined;
}

export class CreateSurveyResultRequest implements ICreateSurveyResultRequest {
    /** The id of the related project */
    projectId!: string;
    /** The template the survey result should be based on */
    surveyTemplateId!: string;

    constructor(data?: ICreateSurveyResultRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.surveyTemplateId = _data["surveyTemplateId"];
        }
    }

    static fromJS(data: any): CreateSurveyResultRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSurveyResultRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["surveyTemplateId"] = this.surveyTemplateId;
        return data;
    }
}

export interface ICreateSurveyResultRequest {
    /** The id of the related project */
    projectId: string;
    /** The template the survey result should be based on */
    surveyTemplateId: string;
}

/** This class is used as a wrapper for all responses given to the client of the API */
export class GuidResponse implements IGuidResponse {
    data?: string;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    readonly operationId?: string | undefined;

    constructor(data?: IGuidResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"];
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.message = _data["message"];
            (<any>this).operationId = _data["operationId"];
        }
    }

    static fromJS(data: any): GuidResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GuidResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        data["operationId"] = this.operationId;
        return data;
    }
}

/** This class is used as a wrapper for all responses given to the client of the API */
export interface IGuidResponse {
    data?: string;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    operationId?: string | undefined;
}

export enum Paa_projectlearningmasterdata_statuscode {
    _1 = 1,
    _2 = 2,
}

export enum Paa_projectlearningmasterdataphase_statuscode {
    _1 = 1,
    _2 = 2,
}

export enum Paa_projectlearningmasterdataphaseState {
    _0 = 0,
    _1 = 1,
}

export enum Paa_projectlearningmasterdatatype_statuscode {
    _1 = 1,
    _2 = 2,
}

export enum Paa_projectlearningmasterdatatypeState {
    _0 = 0,
    _1 = 1,
}

export enum Paa_sektion_statuscode {
    _1 = 1,
    _2 = 2,
}

export enum Paa_sektionState {
    _0 = 0,
    _1 = 1,
}

export enum Paa_surveyiconkey {
    _804240000 = 804240000,
    _804240001 = 804240001,
    _804240002 = 804240002,
    _804240003 = 804240003,
    _804240004 = 804240004,
    _804240005 = 804240005,
    _804240006 = 804240006,
    _804240007 = 804240007,
    _804240008 = 804240008,
    _804240009 = 804240009,
}

export enum Paa_surveyquestionresult_statuscode {
    _1 = 1,
    _2 = 2,
    _804240000 = 804240000,
    _804240001 = 804240001,
}

export enum Paa_surveyquestionresultState {
    _0 = 0,
    _1 = 1,
}

export enum Paa_surveyratingrelevance {
    _804240000 = 804240000,
    _804240001 = 804240001,
}

export enum Paa_surveyresult_statuscode {
    _1 = 1,
    _2 = 2,
    _804240000 = 804240000,
    _804240001 = 804240001,
}

export enum Paa_surveyresultState {
    _0 = 0,
    _1 = 1,
}

export enum Paa_surveyroottopic_statuscode {
    _1 = 1,
    _2 = 2,
}

export enum Paa_surveyroottopicState {
    _0 = 0,
    _1 = 1,
}

export class ProjectDto implements IProjectDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    quoteNumber?: string | undefined;
    projectNumber?: string | undefined;
    currency?: string | undefined;
    tenderDate?: Date | undefined;
    executionStartOn?: Date | undefined;
    executionEndOn?: Date | undefined;
    latestActivityOn?: Date | undefined;
    calculationBudget?: number | undefined;
    calculationBudgetContributionRatio?: number | undefined;
    productionBudget?: number | undefined;
    productionBudgetContributionRatio?: number | undefined;
    latestForecast?: number | undefined;
    latestForecastContributionRatio?: number | undefined;
    workPointUrl?: string | undefined;
    quotationResponsible?: SystemUserDto;
    projectResponsible?: SystemUserDto;
    projectPhase?: ProjectPhaseDto;
    projectType?: ProjectTypeDto[] | undefined;
    section?: SectionDto;
    surveyResults?: SurveyResultDto[] | undefined;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.quoteNumber = _data["quoteNumber"];
            this.projectNumber = _data["projectNumber"];
            this.currency = _data["currency"];
            this.tenderDate = _data["tenderDate"] ? new Date(_data["tenderDate"].toString()) : <any>undefined;
            this.executionStartOn = _data["executionStartOn"] ? new Date(_data["executionStartOn"].toString()) : <any>undefined;
            this.executionEndOn = _data["executionEndOn"] ? new Date(_data["executionEndOn"].toString()) : <any>undefined;
            this.latestActivityOn = _data["latestActivityOn"] ? new Date(_data["latestActivityOn"].toString()) : <any>undefined;
            this.calculationBudget = _data["calculationBudget"];
            this.calculationBudgetContributionRatio = _data["calculationBudgetContributionRatio"];
            this.productionBudget = _data["productionBudget"];
            this.productionBudgetContributionRatio = _data["productionBudgetContributionRatio"];
            this.latestForecast = _data["latestForecast"];
            this.latestForecastContributionRatio = _data["latestForecastContributionRatio"];
            this.workPointUrl = _data["workPointUrl"];
            this.quotationResponsible = _data["quotationResponsible"] ? SystemUserDto.fromJS(_data["quotationResponsible"]) : <any>undefined;
            this.projectResponsible = _data["projectResponsible"] ? SystemUserDto.fromJS(_data["projectResponsible"]) : <any>undefined;
            this.projectPhase = _data["projectPhase"] ? ProjectPhaseDto.fromJS(_data["projectPhase"]) : <any>undefined;
            if (Array.isArray(_data["projectType"])) {
                this.projectType = [] as any;
                for (let item of _data["projectType"])
                    this.projectType!.push(ProjectTypeDto.fromJS(item));
            }
            this.section = _data["section"] ? SectionDto.fromJS(_data["section"]) : <any>undefined;
            if (Array.isArray(_data["surveyResults"])) {
                this.surveyResults = [] as any;
                for (let item of _data["surveyResults"])
                    this.surveyResults!.push(SurveyResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["quoteNumber"] = this.quoteNumber;
        data["projectNumber"] = this.projectNumber;
        data["currency"] = this.currency;
        data["tenderDate"] = this.tenderDate ? this.tenderDate.toISOString() : <any>undefined;
        data["executionStartOn"] = this.executionStartOn ? this.executionStartOn.toISOString() : <any>undefined;
        data["executionEndOn"] = this.executionEndOn ? this.executionEndOn.toISOString() : <any>undefined;
        data["latestActivityOn"] = this.latestActivityOn ? this.latestActivityOn.toISOString() : <any>undefined;
        data["calculationBudget"] = this.calculationBudget;
        data["calculationBudgetContributionRatio"] = this.calculationBudgetContributionRatio;
        data["productionBudget"] = this.productionBudget;
        data["productionBudgetContributionRatio"] = this.productionBudgetContributionRatio;
        data["latestForecast"] = this.latestForecast;
        data["latestForecastContributionRatio"] = this.latestForecastContributionRatio;
        data["workPointUrl"] = this.workPointUrl;
        data["quotationResponsible"] = this.quotationResponsible ? this.quotationResponsible.toJSON() : <any>undefined;
        data["projectResponsible"] = this.projectResponsible ? this.projectResponsible.toJSON() : <any>undefined;
        data["projectPhase"] = this.projectPhase ? this.projectPhase.toJSON() : <any>undefined;
        if (Array.isArray(this.projectType)) {
            data["projectType"] = [];
            for (let item of this.projectType)
                data["projectType"].push(item.toJSON());
        }
        data["section"] = this.section ? this.section.toJSON() : <any>undefined;
        if (Array.isArray(this.surveyResults)) {
            data["surveyResults"] = [];
            for (let item of this.surveyResults)
                data["surveyResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    quoteNumber?: string | undefined;
    projectNumber?: string | undefined;
    currency?: string | undefined;
    tenderDate?: Date | undefined;
    executionStartOn?: Date | undefined;
    executionEndOn?: Date | undefined;
    latestActivityOn?: Date | undefined;
    calculationBudget?: number | undefined;
    calculationBudgetContributionRatio?: number | undefined;
    productionBudget?: number | undefined;
    productionBudgetContributionRatio?: number | undefined;
    latestForecast?: number | undefined;
    latestForecastContributionRatio?: number | undefined;
    workPointUrl?: string | undefined;
    quotationResponsible?: SystemUserDto;
    projectResponsible?: SystemUserDto;
    projectPhase?: ProjectPhaseDto;
    projectType?: ProjectTypeDto[] | undefined;
    section?: SectionDto;
    surveyResults?: SurveyResultDto[] | undefined;
}

/** This class is used as a wrapper for all responses given to the client of the API */
export class ProjectDtoListResponse implements IProjectDtoListResponse {
    data?: ProjectDto[] | undefined;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    readonly operationId?: string | undefined;

    constructor(data?: IProjectDtoListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProjectDto.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.message = _data["message"];
            (<any>this).operationId = _data["operationId"];
        }
    }

    static fromJS(data: any): ProjectDtoListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDtoListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        data["operationId"] = this.operationId;
        return data;
    }
}

/** This class is used as a wrapper for all responses given to the client of the API */
export interface IProjectDtoListResponse {
    data?: ProjectDto[] | undefined;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    operationId?: string | undefined;
}

/** This class is used as a wrapper for all responses given to the client of the API */
export class ProjectDtoResponse implements IProjectDtoResponse {
    data?: ProjectDto;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    readonly operationId?: string | undefined;

    constructor(data?: IProjectDtoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? ProjectDto.fromJS(_data["data"]) : <any>undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.message = _data["message"];
            (<any>this).operationId = _data["operationId"];
        }
    }

    static fromJS(data: any): ProjectDtoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDtoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        data["operationId"] = this.operationId;
        return data;
    }
}

/** This class is used as a wrapper for all responses given to the client of the API */
export interface IProjectDtoResponse {
    data?: ProjectDto;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    operationId?: string | undefined;
}

export class ProjectPhaseDto implements IProjectPhaseDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    position?: number | undefined;
    businessUnit?: BusinessUnitDto;
    surveyTemplates?: SurveyTemplateDto[] | undefined;
    projects?: ProjectDto[] | undefined;
    stateCode?: Paa_projectlearningmasterdataphaseState;
    statusCode?: Paa_projectlearningmasterdata_statuscode;

    constructor(data?: IProjectPhaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.position = _data["position"];
            this.businessUnit = _data["businessUnit"] ? BusinessUnitDto.fromJS(_data["businessUnit"]) : <any>undefined;
            if (Array.isArray(_data["surveyTemplates"])) {
                this.surveyTemplates = [] as any;
                for (let item of _data["surveyTemplates"])
                    this.surveyTemplates!.push(SurveyTemplateDto.fromJS(item));
            }
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectDto.fromJS(item));
            }
            this.stateCode = _data["stateCode"];
            this.statusCode = _data["statusCode"];
        }
    }

    static fromJS(data: any): ProjectPhaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectPhaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["position"] = this.position;
        data["businessUnit"] = this.businessUnit ? this.businessUnit.toJSON() : <any>undefined;
        if (Array.isArray(this.surveyTemplates)) {
            data["surveyTemplates"] = [];
            for (let item of this.surveyTemplates)
                data["surveyTemplates"].push(item.toJSON());
        }
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        data["stateCode"] = this.stateCode;
        data["statusCode"] = this.statusCode;
        return data;
    }
}

export interface IProjectPhaseDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    position?: number | undefined;
    businessUnit?: BusinessUnitDto;
    surveyTemplates?: SurveyTemplateDto[] | undefined;
    projects?: ProjectDto[] | undefined;
    stateCode?: Paa_projectlearningmasterdataphaseState;
    statusCode?: Paa_projectlearningmasterdata_statuscode;
}

/** This class is used as a wrapper for all responses given to the client of the API */
export class ProjectPhaseDtoListResponse implements IProjectPhaseDtoListResponse {
    data?: ProjectPhaseDto[] | undefined;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    readonly operationId?: string | undefined;

    constructor(data?: IProjectPhaseDtoListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProjectPhaseDto.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.message = _data["message"];
            (<any>this).operationId = _data["operationId"];
        }
    }

    static fromJS(data: any): ProjectPhaseDtoListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectPhaseDtoListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        data["operationId"] = this.operationId;
        return data;
    }
}

/** This class is used as a wrapper for all responses given to the client of the API */
export interface IProjectPhaseDtoListResponse {
    data?: ProjectPhaseDto[] | undefined;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    operationId?: string | undefined;
}

export class ProjectTypeDto implements IProjectTypeDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    projects?: ProjectDto[] | undefined;
    businessUnit?: BusinessUnitDto;
    stateCode?: Paa_projectlearningmasterdatatypeState;
    statusCode?: Paa_projectlearningmasterdatatype_statuscode;

    constructor(data?: IProjectTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectDto.fromJS(item));
            }
            this.businessUnit = _data["businessUnit"] ? BusinessUnitDto.fromJS(_data["businessUnit"]) : <any>undefined;
            this.stateCode = _data["stateCode"];
            this.statusCode = _data["statusCode"];
        }
    }

    static fromJS(data: any): ProjectTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        data["businessUnit"] = this.businessUnit ? this.businessUnit.toJSON() : <any>undefined;
        data["stateCode"] = this.stateCode;
        data["statusCode"] = this.statusCode;
        return data;
    }
}

export interface IProjectTypeDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    projects?: ProjectDto[] | undefined;
    businessUnit?: BusinessUnitDto;
    stateCode?: Paa_projectlearningmasterdatatypeState;
    statusCode?: Paa_projectlearningmasterdatatype_statuscode;
}

/** This class is used as a wrapper for all responses given to the client of the API */
export class ProjectTypeDtoListResponse implements IProjectTypeDtoListResponse {
    data?: ProjectTypeDto[] | undefined;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    readonly operationId?: string | undefined;

    constructor(data?: IProjectTypeDtoListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ProjectTypeDto.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.message = _data["message"];
            (<any>this).operationId = _data["operationId"];
        }
    }

    static fromJS(data: any): ProjectTypeDtoListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTypeDtoListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        data["operationId"] = this.operationId;
        return data;
    }
}

/** This class is used as a wrapper for all responses given to the client of the API */
export interface IProjectTypeDtoListResponse {
    data?: ProjectTypeDto[] | undefined;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    operationId?: string | undefined;
}

export class ReasonActionSaveAsDraftOrCompletedRequestDto implements IReasonActionSaveAsDraftOrCompletedRequestDto {
    surveyResultId!: string;
    surveyQuestionResults?: ReasonActionSurveyQuestionResultDto[] | undefined;

    constructor(data?: IReasonActionSaveAsDraftOrCompletedRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyResultId = _data["surveyResultId"];
            if (Array.isArray(_data["surveyQuestionResults"])) {
                this.surveyQuestionResults = [] as any;
                for (let item of _data["surveyQuestionResults"])
                    this.surveyQuestionResults!.push(ReasonActionSurveyQuestionResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReasonActionSaveAsDraftOrCompletedRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonActionSaveAsDraftOrCompletedRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyResultId"] = this.surveyResultId;
        if (Array.isArray(this.surveyQuestionResults)) {
            data["surveyQuestionResults"] = [];
            for (let item of this.surveyQuestionResults)
                data["surveyQuestionResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReasonActionSaveAsDraftOrCompletedRequestDto {
    surveyResultId: string;
    surveyQuestionResults?: ReasonActionSurveyQuestionResultDto[] | undefined;
}

export class ReasonActionSurveyQuestionResultDto implements IReasonActionSurveyQuestionResultDto {
    surveyQuestionResultId!: string;
    reason?: string | undefined;
    action?: string | undefined;

    constructor(data?: IReasonActionSurveyQuestionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyQuestionResultId = _data["surveyQuestionResultId"];
            this.reason = _data["reason"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): ReasonActionSurveyQuestionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonActionSurveyQuestionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyQuestionResultId"] = this.surveyQuestionResultId;
        data["reason"] = this.reason;
        data["action"] = this.action;
        return data;
    }
}

export interface IReasonActionSurveyQuestionResultDto {
    surveyQuestionResultId: string;
    reason?: string | undefined;
    action?: string | undefined;
}

export enum Role {
    _0 = 0,
    _1 = 1,
}

export class SectionDto implements ISectionDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    sectionNumber?: number | undefined;
    sectionManager?: SystemUserDto;
    sectionMembers?: SystemUserDto[] | undefined;
    surveyTopicKpis?: SurveyTopicKpiDto[] | undefined;
    childSections?: SectionDto[] | undefined;
    parentSection?: SectionDto;
    stateCode?: Paa_sektionState;
    statusCode?: Paa_sektion_statuscode;

    constructor(data?: ISectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.sectionNumber = _data["sectionNumber"];
            this.sectionManager = _data["sectionManager"] ? SystemUserDto.fromJS(_data["sectionManager"]) : <any>undefined;
            if (Array.isArray(_data["sectionMembers"])) {
                this.sectionMembers = [] as any;
                for (let item of _data["sectionMembers"])
                    this.sectionMembers!.push(SystemUserDto.fromJS(item));
            }
            if (Array.isArray(_data["surveyTopicKpis"])) {
                this.surveyTopicKpis = [] as any;
                for (let item of _data["surveyTopicKpis"])
                    this.surveyTopicKpis!.push(SurveyTopicKpiDto.fromJS(item));
            }
            if (Array.isArray(_data["childSections"])) {
                this.childSections = [] as any;
                for (let item of _data["childSections"])
                    this.childSections!.push(SectionDto.fromJS(item));
            }
            this.parentSection = _data["parentSection"] ? SectionDto.fromJS(_data["parentSection"]) : <any>undefined;
            this.stateCode = _data["stateCode"];
            this.statusCode = _data["statusCode"];
        }
    }

    static fromJS(data: any): SectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["sectionNumber"] = this.sectionNumber;
        data["sectionManager"] = this.sectionManager ? this.sectionManager.toJSON() : <any>undefined;
        if (Array.isArray(this.sectionMembers)) {
            data["sectionMembers"] = [];
            for (let item of this.sectionMembers)
                data["sectionMembers"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyTopicKpis)) {
            data["surveyTopicKpis"] = [];
            for (let item of this.surveyTopicKpis)
                data["surveyTopicKpis"].push(item.toJSON());
        }
        if (Array.isArray(this.childSections)) {
            data["childSections"] = [];
            for (let item of this.childSections)
                data["childSections"].push(item.toJSON());
        }
        data["parentSection"] = this.parentSection ? this.parentSection.toJSON() : <any>undefined;
        data["stateCode"] = this.stateCode;
        data["statusCode"] = this.statusCode;
        return data;
    }
}

export interface ISectionDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    sectionNumber?: number | undefined;
    sectionManager?: SystemUserDto;
    sectionMembers?: SystemUserDto[] | undefined;
    surveyTopicKpis?: SurveyTopicKpiDto[] | undefined;
    childSections?: SectionDto[] | undefined;
    parentSection?: SectionDto;
    stateCode?: Paa_sektionState;
    statusCode?: Paa_sektion_statuscode;
}

/** This class is used as a wrapper for all responses given to the client of the API */
export class SectionDtoListResponse implements ISectionDtoListResponse {
    data?: SectionDto[] | undefined;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    readonly operationId?: string | undefined;

    constructor(data?: ISectionDtoListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SectionDto.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.message = _data["message"];
            (<any>this).operationId = _data["operationId"];
        }
    }

    static fromJS(data: any): SectionDtoListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SectionDtoListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        data["operationId"] = this.operationId;
        return data;
    }
}

/** This class is used as a wrapper for all responses given to the client of the API */
export interface ISectionDtoListResponse {
    data?: SectionDto[] | undefined;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    operationId?: string | undefined;
}

export class SurveyQuestionDto implements ISurveyQuestionDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    question?: string | undefined;
    position?: number | undefined;
    surveyQuestionResults?: SurveyQuestionResultDto[] | undefined;
    surveyTopic?: SurveyTopicDto;

    constructor(data?: ISurveyQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.question = _data["question"];
            this.position = _data["position"];
            if (Array.isArray(_data["surveyQuestionResults"])) {
                this.surveyQuestionResults = [] as any;
                for (let item of _data["surveyQuestionResults"])
                    this.surveyQuestionResults!.push(SurveyQuestionResultDto.fromJS(item));
            }
            this.surveyTopic = _data["surveyTopic"] ? SurveyTopicDto.fromJS(_data["surveyTopic"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SurveyQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["question"] = this.question;
        data["position"] = this.position;
        if (Array.isArray(this.surveyQuestionResults)) {
            data["surveyQuestionResults"] = [];
            for (let item of this.surveyQuestionResults)
                data["surveyQuestionResults"].push(item.toJSON());
        }
        data["surveyTopic"] = this.surveyTopic ? this.surveyTopic.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISurveyQuestionDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    question?: string | undefined;
    position?: number | undefined;
    surveyQuestionResults?: SurveyQuestionResultDto[] | undefined;
    surveyTopic?: SurveyTopicDto;
}

export class SurveyQuestionResultCompletedRequest implements ISurveyQuestionResultCompletedRequest {
    surveyQuestionResultId!: string;
    relevance?: boolean | undefined;
    rating?: number | undefined;
    comment?: string | undefined;
    goodIdea?: string | undefined;

    constructor(data?: ISurveyQuestionResultCompletedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyQuestionResultId = _data["surveyQuestionResultId"];
            this.relevance = _data["relevance"];
            this.rating = _data["rating"];
            this.comment = _data["comment"];
            this.goodIdea = _data["goodIdea"];
        }
    }

    static fromJS(data: any): SurveyQuestionResultCompletedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionResultCompletedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyQuestionResultId"] = this.surveyQuestionResultId;
        data["relevance"] = this.relevance;
        data["rating"] = this.rating;
        data["comment"] = this.comment;
        data["goodIdea"] = this.goodIdea;
        return data;
    }
}

export interface ISurveyQuestionResultCompletedRequest {
    surveyQuestionResultId: string;
    relevance?: boolean | undefined;
    rating?: number | undefined;
    comment?: string | undefined;
    goodIdea?: string | undefined;
}

export class SurveyQuestionResultDraftRequest implements ISurveyQuestionResultDraftRequest {
    surveyQuestionResultId!: string;
    relevance?: boolean | undefined;
    rating?: number | undefined;
    comment?: string | undefined;
    goodIdea?: string | undefined;

    constructor(data?: ISurveyQuestionResultDraftRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyQuestionResultId = _data["surveyQuestionResultId"];
            this.relevance = _data["relevance"];
            this.rating = _data["rating"];
            this.comment = _data["comment"];
            this.goodIdea = _data["goodIdea"];
        }
    }

    static fromJS(data: any): SurveyQuestionResultDraftRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionResultDraftRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyQuestionResultId"] = this.surveyQuestionResultId;
        data["relevance"] = this.relevance;
        data["rating"] = this.rating;
        data["comment"] = this.comment;
        data["goodIdea"] = this.goodIdea;
        return data;
    }
}

export interface ISurveyQuestionResultDraftRequest {
    surveyQuestionResultId: string;
    relevance?: boolean | undefined;
    rating?: number | undefined;
    comment?: string | undefined;
    goodIdea?: string | undefined;
}

export class SurveyQuestionResultDto implements ISurveyQuestionResultDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    question?: string | undefined;
    position?: number | undefined;
    rating?: number | undefined;
    comment?: string | undefined;
    goodIdea?: string | undefined;
    cause?: string | undefined;
    action?: string | undefined;
    ratingRelevance?: Paa_surveyratingrelevance;
    stateCode?: Paa_surveyquestionresultState;
    statusCode?: Paa_surveyquestionresult_statuscode;
    surveyTopicResult?: SurveyTopicResultDto;
    surveyQuestion?: SurveyQuestionDto;

    constructor(data?: ISurveyQuestionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.question = _data["question"];
            this.position = _data["position"];
            this.rating = _data["rating"];
            this.comment = _data["comment"];
            this.goodIdea = _data["goodIdea"];
            this.cause = _data["cause"];
            this.action = _data["action"];
            this.ratingRelevance = _data["ratingRelevance"];
            this.stateCode = _data["stateCode"];
            this.statusCode = _data["statusCode"];
            this.surveyTopicResult = _data["surveyTopicResult"] ? SurveyTopicResultDto.fromJS(_data["surveyTopicResult"]) : <any>undefined;
            this.surveyQuestion = _data["surveyQuestion"] ? SurveyQuestionDto.fromJS(_data["surveyQuestion"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SurveyQuestionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyQuestionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["question"] = this.question;
        data["position"] = this.position;
        data["rating"] = this.rating;
        data["comment"] = this.comment;
        data["goodIdea"] = this.goodIdea;
        data["cause"] = this.cause;
        data["action"] = this.action;
        data["ratingRelevance"] = this.ratingRelevance;
        data["stateCode"] = this.stateCode;
        data["statusCode"] = this.statusCode;
        data["surveyTopicResult"] = this.surveyTopicResult ? this.surveyTopicResult.toJSON() : <any>undefined;
        data["surveyQuestion"] = this.surveyQuestion ? this.surveyQuestion.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISurveyQuestionResultDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    question?: string | undefined;
    position?: number | undefined;
    rating?: number | undefined;
    comment?: string | undefined;
    goodIdea?: string | undefined;
    cause?: string | undefined;
    action?: string | undefined;
    ratingRelevance?: Paa_surveyratingrelevance;
    stateCode?: Paa_surveyquestionresultState;
    statusCode?: Paa_surveyquestionresult_statuscode;
    surveyTopicResult?: SurveyTopicResultDto;
    surveyQuestion?: SurveyQuestionDto;
}

export class SurveyResultDto implements ISurveyResultDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    completedOn?: Date | undefined;
    completedBy?: SystemUserDto;
    reasonActionCompletedOn?: Date | undefined;
    reasonActionCompletedBy?: SystemUserDto;
    stateCode?: Paa_surveyresultState;
    statusCode?: Paa_surveyresult_statuscode;
    project?: ProjectDto;
    surveyTemplate?: SurveyTemplateDto;
    surveyTopicResults?: SurveyTopicResultDto[] | undefined;

    constructor(data?: ISurveyResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.completedOn = _data["completedOn"] ? new Date(_data["completedOn"].toString()) : <any>undefined;
            this.completedBy = _data["completedBy"] ? SystemUserDto.fromJS(_data["completedBy"]) : <any>undefined;
            this.reasonActionCompletedOn = _data["reasonActionCompletedOn"] ? new Date(_data["reasonActionCompletedOn"].toString()) : <any>undefined;
            this.reasonActionCompletedBy = _data["reasonActionCompletedBy"] ? SystemUserDto.fromJS(_data["reasonActionCompletedBy"]) : <any>undefined;
            this.stateCode = _data["stateCode"];
            this.statusCode = _data["statusCode"];
            this.project = _data["project"] ? ProjectDto.fromJS(_data["project"]) : <any>undefined;
            this.surveyTemplate = _data["surveyTemplate"] ? SurveyTemplateDto.fromJS(_data["surveyTemplate"]) : <any>undefined;
            if (Array.isArray(_data["surveyTopicResults"])) {
                this.surveyTopicResults = [] as any;
                for (let item of _data["surveyTopicResults"])
                    this.surveyTopicResults!.push(SurveyTopicResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["completedOn"] = this.completedOn ? this.completedOn.toISOString() : <any>undefined;
        data["completedBy"] = this.completedBy ? this.completedBy.toJSON() : <any>undefined;
        data["reasonActionCompletedOn"] = this.reasonActionCompletedOn ? this.reasonActionCompletedOn.toISOString() : <any>undefined;
        data["reasonActionCompletedBy"] = this.reasonActionCompletedBy ? this.reasonActionCompletedBy.toJSON() : <any>undefined;
        data["stateCode"] = this.stateCode;
        data["statusCode"] = this.statusCode;
        data["project"] = this.project ? this.project.toJSON() : <any>undefined;
        data["surveyTemplate"] = this.surveyTemplate ? this.surveyTemplate.toJSON() : <any>undefined;
        if (Array.isArray(this.surveyTopicResults)) {
            data["surveyTopicResults"] = [];
            for (let item of this.surveyTopicResults)
                data["surveyTopicResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyResultDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    completedOn?: Date | undefined;
    completedBy?: SystemUserDto;
    reasonActionCompletedOn?: Date | undefined;
    reasonActionCompletedBy?: SystemUserDto;
    stateCode?: Paa_surveyresultState;
    statusCode?: Paa_surveyresult_statuscode;
    project?: ProjectDto;
    surveyTemplate?: SurveyTemplateDto;
    surveyTopicResults?: SurveyTopicResultDto[] | undefined;
}

/** This class is used as a wrapper for all responses given to the client of the API */
export class SurveyResultDtoListResponse implements ISurveyResultDtoListResponse {
    data?: SurveyResultDto[] | undefined;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    readonly operationId?: string | undefined;

    constructor(data?: ISurveyResultDtoListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SurveyResultDto.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.message = _data["message"];
            (<any>this).operationId = _data["operationId"];
        }
    }

    static fromJS(data: any): SurveyResultDtoListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResultDtoListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        data["operationId"] = this.operationId;
        return data;
    }
}

/** This class is used as a wrapper for all responses given to the client of the API */
export interface ISurveyResultDtoListResponse {
    data?: SurveyResultDto[] | undefined;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    operationId?: string | undefined;
}

/** This class is used as a wrapper for all responses given to the client of the API */
export class SurveyResultDtoResponse implements ISurveyResultDtoResponse {
    data?: SurveyResultDto;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    readonly operationId?: string | undefined;

    constructor(data?: ISurveyResultDtoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SurveyResultDto.fromJS(_data["data"]) : <any>undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.message = _data["message"];
            (<any>this).operationId = _data["operationId"];
        }
    }

    static fromJS(data: any): SurveyResultDtoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResultDtoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        data["operationId"] = this.operationId;
        return data;
    }
}

/** This class is used as a wrapper for all responses given to the client of the API */
export interface ISurveyResultDtoResponse {
    data?: SurveyResultDto;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    operationId?: string | undefined;
}

export class SurveyResultSaveAsCompletedRequestDto implements ISurveyResultSaveAsCompletedRequestDto {
    surveyResultId!: string;
    surveyQuestionResults?: SurveyQuestionResultCompletedRequest[] | undefined;

    constructor(data?: ISurveyResultSaveAsCompletedRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyResultId = _data["surveyResultId"];
            if (Array.isArray(_data["surveyQuestionResults"])) {
                this.surveyQuestionResults = [] as any;
                for (let item of _data["surveyQuestionResults"])
                    this.surveyQuestionResults!.push(SurveyQuestionResultCompletedRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyResultSaveAsCompletedRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResultSaveAsCompletedRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyResultId"] = this.surveyResultId;
        if (Array.isArray(this.surveyQuestionResults)) {
            data["surveyQuestionResults"] = [];
            for (let item of this.surveyQuestionResults)
                data["surveyQuestionResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyResultSaveAsCompletedRequestDto {
    surveyResultId: string;
    surveyQuestionResults?: SurveyQuestionResultCompletedRequest[] | undefined;
}

export class SurveyResultSaveAsDraftRequestDto implements ISurveyResultSaveAsDraftRequestDto {
    surveyResultId!: string;
    surveyQuestionResults?: SurveyQuestionResultDraftRequest[] | undefined;

    constructor(data?: ISurveyResultSaveAsDraftRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.surveyResultId = _data["surveyResultId"];
            if (Array.isArray(_data["surveyQuestionResults"])) {
                this.surveyQuestionResults = [] as any;
                for (let item of _data["surveyQuestionResults"])
                    this.surveyQuestionResults!.push(SurveyQuestionResultDraftRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyResultSaveAsDraftRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyResultSaveAsDraftRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["surveyResultId"] = this.surveyResultId;
        if (Array.isArray(this.surveyQuestionResults)) {
            data["surveyQuestionResults"] = [];
            for (let item of this.surveyQuestionResults)
                data["surveyQuestionResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyResultSaveAsDraftRequestDto {
    surveyResultId: string;
    surveyQuestionResults?: SurveyQuestionResultDraftRequest[] | undefined;
}

export class SurveyRootTopicDto implements ISurveyRootTopicDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    position?: number | undefined;
    iconKey?: Paa_surveyiconkey;
    businessUnit?: BusinessUnitDto;
    surveyTopics?: SurveyTopicDto[] | undefined;
    stateCode?: Paa_surveyroottopicState;
    statusCode?: Paa_surveyroottopic_statuscode;

    constructor(data?: ISurveyRootTopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.position = _data["position"];
            this.iconKey = _data["iconKey"];
            this.businessUnit = _data["businessUnit"] ? BusinessUnitDto.fromJS(_data["businessUnit"]) : <any>undefined;
            if (Array.isArray(_data["surveyTopics"])) {
                this.surveyTopics = [] as any;
                for (let item of _data["surveyTopics"])
                    this.surveyTopics!.push(SurveyTopicDto.fromJS(item));
            }
            this.stateCode = _data["stateCode"];
            this.statusCode = _data["statusCode"];
        }
    }

    static fromJS(data: any): SurveyRootTopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyRootTopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["position"] = this.position;
        data["iconKey"] = this.iconKey;
        data["businessUnit"] = this.businessUnit ? this.businessUnit.toJSON() : <any>undefined;
        if (Array.isArray(this.surveyTopics)) {
            data["surveyTopics"] = [];
            for (let item of this.surveyTopics)
                data["surveyTopics"].push(item.toJSON());
        }
        data["stateCode"] = this.stateCode;
        data["statusCode"] = this.statusCode;
        return data;
    }
}

export interface ISurveyRootTopicDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    position?: number | undefined;
    iconKey?: Paa_surveyiconkey;
    businessUnit?: BusinessUnitDto;
    surveyTopics?: SurveyTopicDto[] | undefined;
    stateCode?: Paa_surveyroottopicState;
    statusCode?: Paa_surveyroottopic_statuscode;
}

/** This class is used as a wrapper for all responses given to the client of the API */
export class SurveyRootTopicDtoListResponse implements ISurveyRootTopicDtoListResponse {
    data?: SurveyRootTopicDto[] | undefined;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    readonly operationId?: string | undefined;

    constructor(data?: ISurveyRootTopicDtoListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SurveyRootTopicDto.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.message = _data["message"];
            (<any>this).operationId = _data["operationId"];
        }
    }

    static fromJS(data: any): SurveyRootTopicDtoListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyRootTopicDtoListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        data["operationId"] = this.operationId;
        return data;
    }
}

/** This class is used as a wrapper for all responses given to the client of the API */
export interface ISurveyRootTopicDtoListResponse {
    data?: SurveyRootTopicDto[] | undefined;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    operationId?: string | undefined;
}

export class SurveyTemplateDto implements ISurveyTemplateDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    position?: number | undefined;
    businessUnit?: BusinessUnitDto;
    projectPhase?: ProjectPhaseDto;
    surveyTopics?: SurveyTopicDto[] | undefined;
    surveyResults?: SurveyResultDto[] | undefined;

    constructor(data?: ISurveyTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.position = _data["position"];
            this.businessUnit = _data["businessUnit"] ? BusinessUnitDto.fromJS(_data["businessUnit"]) : <any>undefined;
            this.projectPhase = _data["projectPhase"] ? ProjectPhaseDto.fromJS(_data["projectPhase"]) : <any>undefined;
            if (Array.isArray(_data["surveyTopics"])) {
                this.surveyTopics = [] as any;
                for (let item of _data["surveyTopics"])
                    this.surveyTopics!.push(SurveyTopicDto.fromJS(item));
            }
            if (Array.isArray(_data["surveyResults"])) {
                this.surveyResults = [] as any;
                for (let item of _data["surveyResults"])
                    this.surveyResults!.push(SurveyResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["position"] = this.position;
        data["businessUnit"] = this.businessUnit ? this.businessUnit.toJSON() : <any>undefined;
        data["projectPhase"] = this.projectPhase ? this.projectPhase.toJSON() : <any>undefined;
        if (Array.isArray(this.surveyTopics)) {
            data["surveyTopics"] = [];
            for (let item of this.surveyTopics)
                data["surveyTopics"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyResults)) {
            data["surveyResults"] = [];
            for (let item of this.surveyResults)
                data["surveyResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyTemplateDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    position?: number | undefined;
    businessUnit?: BusinessUnitDto;
    projectPhase?: ProjectPhaseDto;
    surveyTopics?: SurveyTopicDto[] | undefined;
    surveyResults?: SurveyResultDto[] | undefined;
}

/** This class is used as a wrapper for all responses given to the client of the API */
export class SurveyTemplateDtoListResponse implements ISurveyTemplateDtoListResponse {
    data?: SurveyTemplateDto[] | undefined;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    readonly operationId?: string | undefined;

    constructor(data?: ISurveyTemplateDtoListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SurveyTemplateDto.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.message = _data["message"];
            (<any>this).operationId = _data["operationId"];
        }
    }

    static fromJS(data: any): SurveyTemplateDtoListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyTemplateDtoListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        data["operationId"] = this.operationId;
        return data;
    }
}

/** This class is used as a wrapper for all responses given to the client of the API */
export interface ISurveyTemplateDtoListResponse {
    data?: SurveyTemplateDto[] | undefined;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    operationId?: string | undefined;
}

export class SurveyTopicDto implements ISurveyTopicDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    defaultGoalKpi?: number | undefined;
    defaultMinKpi?: number | undefined;
    surveyTopicKpis?: SurveyTopicKpiDto[] | undefined;
    surveyRootTopic?: SurveyRootTopicDto;
    surveyTemplate?: SurveyTemplateDto;
    surveyQuestions?: SurveyQuestionDto[] | undefined;
    surveyTopicResults?: SurveyTopicResultDto[] | undefined;

    constructor(data?: ISurveyTopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.defaultGoalKpi = _data["defaultGoalKpi"];
            this.defaultMinKpi = _data["defaultMinKpi"];
            if (Array.isArray(_data["surveyTopicKpis"])) {
                this.surveyTopicKpis = [] as any;
                for (let item of _data["surveyTopicKpis"])
                    this.surveyTopicKpis!.push(SurveyTopicKpiDto.fromJS(item));
            }
            this.surveyRootTopic = _data["surveyRootTopic"] ? SurveyRootTopicDto.fromJS(_data["surveyRootTopic"]) : <any>undefined;
            this.surveyTemplate = _data["surveyTemplate"] ? SurveyTemplateDto.fromJS(_data["surveyTemplate"]) : <any>undefined;
            if (Array.isArray(_data["surveyQuestions"])) {
                this.surveyQuestions = [] as any;
                for (let item of _data["surveyQuestions"])
                    this.surveyQuestions!.push(SurveyQuestionDto.fromJS(item));
            }
            if (Array.isArray(_data["surveyTopicResults"])) {
                this.surveyTopicResults = [] as any;
                for (let item of _data["surveyTopicResults"])
                    this.surveyTopicResults!.push(SurveyTopicResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyTopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyTopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["defaultGoalKpi"] = this.defaultGoalKpi;
        data["defaultMinKpi"] = this.defaultMinKpi;
        if (Array.isArray(this.surveyTopicKpis)) {
            data["surveyTopicKpis"] = [];
            for (let item of this.surveyTopicKpis)
                data["surveyTopicKpis"].push(item.toJSON());
        }
        data["surveyRootTopic"] = this.surveyRootTopic ? this.surveyRootTopic.toJSON() : <any>undefined;
        data["surveyTemplate"] = this.surveyTemplate ? this.surveyTemplate.toJSON() : <any>undefined;
        if (Array.isArray(this.surveyQuestions)) {
            data["surveyQuestions"] = [];
            for (let item of this.surveyQuestions)
                data["surveyQuestions"].push(item.toJSON());
        }
        if (Array.isArray(this.surveyTopicResults)) {
            data["surveyTopicResults"] = [];
            for (let item of this.surveyTopicResults)
                data["surveyTopicResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyTopicDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    defaultGoalKpi?: number | undefined;
    defaultMinKpi?: number | undefined;
    surveyTopicKpis?: SurveyTopicKpiDto[] | undefined;
    surveyRootTopic?: SurveyRootTopicDto;
    surveyTemplate?: SurveyTemplateDto;
    surveyQuestions?: SurveyQuestionDto[] | undefined;
    surveyTopicResults?: SurveyTopicResultDto[] | undefined;
}

export class SurveyTopicKpiDto implements ISurveyTopicKpiDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    goalKpi?: number | undefined;
    minKpi?: number | undefined;
    surveyTopic?: SurveyTopicDto;
    section?: SectionDto;

    constructor(data?: ISurveyTopicKpiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.goalKpi = _data["goalKpi"];
            this.minKpi = _data["minKpi"];
            this.surveyTopic = _data["surveyTopic"] ? SurveyTopicDto.fromJS(_data["surveyTopic"]) : <any>undefined;
            this.section = _data["section"] ? SectionDto.fromJS(_data["section"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SurveyTopicKpiDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyTopicKpiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["goalKpi"] = this.goalKpi;
        data["minKpi"] = this.minKpi;
        data["surveyTopic"] = this.surveyTopic ? this.surveyTopic.toJSON() : <any>undefined;
        data["section"] = this.section ? this.section.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISurveyTopicKpiDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    goalKpi?: number | undefined;
    minKpi?: number | undefined;
    surveyTopic?: SurveyTopicDto;
    section?: SectionDto;
}

export class SurveyTopicResultDto implements ISurveyTopicResultDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    goalKpi?: number | undefined;
    minKpi?: number | undefined;
    position?: number | undefined;
    averageRating?: number | undefined;
    numberOfQuestionsUnderMinKpi?: number | undefined;
    surveyResult?: SurveyResultDto;
    surveyTopic?: SurveyTopicDto;
    surveyRootTopic?: SurveyRootTopicDto;
    surveyQuestionResults?: SurveyQuestionResultDto[] | undefined;

    constructor(data?: ISurveyTopicResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.goalKpi = _data["goalKpi"];
            this.minKpi = _data["minKpi"];
            this.position = _data["position"];
            this.averageRating = _data["averageRating"];
            this.numberOfQuestionsUnderMinKpi = _data["numberOfQuestionsUnderMinKpi"];
            this.surveyResult = _data["surveyResult"] ? SurveyResultDto.fromJS(_data["surveyResult"]) : <any>undefined;
            this.surveyTopic = _data["surveyTopic"] ? SurveyTopicDto.fromJS(_data["surveyTopic"]) : <any>undefined;
            this.surveyRootTopic = _data["surveyRootTopic"] ? SurveyRootTopicDto.fromJS(_data["surveyRootTopic"]) : <any>undefined;
            if (Array.isArray(_data["surveyQuestionResults"])) {
                this.surveyQuestionResults = [] as any;
                for (let item of _data["surveyQuestionResults"])
                    this.surveyQuestionResults!.push(SurveyQuestionResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SurveyTopicResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SurveyTopicResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["goalKpi"] = this.goalKpi;
        data["minKpi"] = this.minKpi;
        data["position"] = this.position;
        data["averageRating"] = this.averageRating;
        data["numberOfQuestionsUnderMinKpi"] = this.numberOfQuestionsUnderMinKpi;
        data["surveyResult"] = this.surveyResult ? this.surveyResult.toJSON() : <any>undefined;
        data["surveyTopic"] = this.surveyTopic ? this.surveyTopic.toJSON() : <any>undefined;
        data["surveyRootTopic"] = this.surveyRootTopic ? this.surveyRootTopic.toJSON() : <any>undefined;
        if (Array.isArray(this.surveyQuestionResults)) {
            data["surveyQuestionResults"] = [];
            for (let item of this.surveyQuestionResults)
                data["surveyQuestionResults"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISurveyTopicResultDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    goalKpi?: number | undefined;
    minKpi?: number | undefined;
    position?: number | undefined;
    averageRating?: number | undefined;
    numberOfQuestionsUnderMinKpi?: number | undefined;
    surveyResult?: SurveyResultDto;
    surveyTopic?: SurveyTopicDto;
    surveyRootTopic?: SurveyRootTopicDto;
    surveyQuestionResults?: SurveyQuestionResultDto[] | undefined;
}

export class SystemUserDto implements ISystemUserDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    section?: SectionDto;
    businessUnit?: BusinessUnitDto;
    isQuotationResponsible?: boolean | undefined;
    isProjectResponsible?: boolean | undefined;
    isProjectParticipant?: boolean | undefined;
    portfolioManagerIn?: SectionDto[] | undefined;
    sectionManagerIn?: SectionDto[] | undefined;

    constructor(data?: ISystemUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.fullName = _data["fullName"];
            this.email = _data["email"];
            this.section = _data["section"] ? SectionDto.fromJS(_data["section"]) : <any>undefined;
            this.businessUnit = _data["businessUnit"] ? BusinessUnitDto.fromJS(_data["businessUnit"]) : <any>undefined;
            this.isQuotationResponsible = _data["isQuotationResponsible"];
            this.isProjectResponsible = _data["isProjectResponsible"];
            this.isProjectParticipant = _data["isProjectParticipant"];
            if (Array.isArray(_data["portfolioManagerIn"])) {
                this.portfolioManagerIn = [] as any;
                for (let item of _data["portfolioManagerIn"])
                    this.portfolioManagerIn!.push(SectionDto.fromJS(item));
            }
            if (Array.isArray(_data["sectionManagerIn"])) {
                this.sectionManagerIn = [] as any;
                for (let item of _data["sectionManagerIn"])
                    this.sectionManagerIn!.push(SectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SystemUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["fullName"] = this.fullName;
        data["email"] = this.email;
        data["section"] = this.section ? this.section.toJSON() : <any>undefined;
        data["businessUnit"] = this.businessUnit ? this.businessUnit.toJSON() : <any>undefined;
        data["isQuotationResponsible"] = this.isQuotationResponsible;
        data["isProjectResponsible"] = this.isProjectResponsible;
        data["isProjectParticipant"] = this.isProjectParticipant;
        if (Array.isArray(this.portfolioManagerIn)) {
            data["portfolioManagerIn"] = [];
            for (let item of this.portfolioManagerIn)
                data["portfolioManagerIn"].push(item.toJSON());
        }
        if (Array.isArray(this.sectionManagerIn)) {
            data["sectionManagerIn"] = [];
            for (let item of this.sectionManagerIn)
                data["sectionManagerIn"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISystemUserDto {
    id?: string | undefined;
    name?: string | undefined;
    modifiedOn?: Date | undefined;
    fullName?: string | undefined;
    email?: string | undefined;
    section?: SectionDto;
    businessUnit?: BusinessUnitDto;
    isQuotationResponsible?: boolean | undefined;
    isProjectResponsible?: boolean | undefined;
    isProjectParticipant?: boolean | undefined;
    portfolioManagerIn?: SectionDto[] | undefined;
    sectionManagerIn?: SectionDto[] | undefined;
}

/** This class is used as a wrapper for all responses given to the client of the API */
export class SystemUserDtoResponse implements ISystemUserDtoResponse {
    data?: SystemUserDto;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    readonly operationId?: string | undefined;

    constructor(data?: ISystemUserDtoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? SystemUserDto.fromJS(_data["data"]) : <any>undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.message = _data["message"];
            (<any>this).operationId = _data["operationId"];
        }
    }

    static fromJS(data: any): SystemUserDtoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SystemUserDtoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        data["operationId"] = this.operationId;
        return data;
    }
}

/** This class is used as a wrapper for all responses given to the client of the API */
export interface ISystemUserDtoResponse {
    data?: SystemUserDto;
    succeeded?: boolean;
    errors?: string[] | undefined;
    message?: string | undefined;
    operationId?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}